import type id from "./id";
import tablesEn from "./tables/en";
import tosAndPapEn from "./tos-and-pap/en";

const en: typeof id = {
	components: {
		table: {
			...tablesEn,
		},
		tos_and_pap: {
			...tosAndPapEn,
		},
	},
};

export default en;
